import { Routes, RouterModule } from "@angular/router";
import { BusTrackerActivationComponent } from "./bus-tracker-activation/bus-tracker-activation.component";
import { BusMaintenanceComponent } from "./bus-maintenance/bus-maintenance.component";
import { BusAlertTypeMaintenanceComponent } from "./bus-alert-type-maintenance/bus-alert-type-maintenance.component";
import { BusRouteTypeMaintenanceComponent } from "./bus-route-type-maintenance/bus-route-type-maintenance.component";
import { BusTrackerScanHistoryComponent } from "./bus-tracker-scan-history/bus-tracker-scan-history.component";
import { BusTrackerGeoFenceMaintenanceComponent } from "./bus-tracker-geo-fence-maintenance/bus-tracker-geo-fence-maintenance.component";
import { BusTrackerBusHistoryComponent } from "./bus-tracker-bus-history/bus-tracker-bus-history.component";
import { BusTrackerMainMapComponent } from "./bus-tracker-main-map/bus-tracker-main-map.component";
import { BusTrackerSettingsComponent } from "./bus-tracker-settings/bus-tracker-settings.component";
import { BusOverviewTableComponent } from "./bus-overview-table/bus-overview-table.component";
import { BusTrackerGeoFenceHistoryComponent } from "./bus-tracker-geo-fence-history/bus-tracker-geo-fence-history.component";
import { BusTrackerMapDebugComponent } from "./bus-tracker-map-debug/bus-tracker-map-debug.component";
import { AuthguardService } from "../master/services";

export const BusTrackerRoutes: Routes = [
	{ path: "", redirectTo: "/bustracker/map", pathMatch: "full" },
	{
		path: "map",
		data: { title: "Transit Map" },
		component: BusTrackerMainMapComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "activation",
		data: { title: "Transit Activation" },
		component: BusTrackerActivationComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "busmaintenance",
		data: { title: "Bus Maintenance" },
		component: BusMaintenanceComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "alerttype",
		data: { title: "Alert Type Maintenance" },
		component: BusAlertTypeMaintenanceComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "routetype",
		data: { title: "Route Type Maintenance" },
		component: BusRouteTypeMaintenanceComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "geofencing",
		data: { title: "Geo Fencing Maintenance" },
		component: BusTrackerGeoFenceMaintenanceComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "scanhistory",
		data: { title: "Scan History" },
		component: BusTrackerScanHistoryComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "bustrackerhistory",
		data: { title: "Bus History" },
		component: BusTrackerBusHistoryComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "settings",
		data: { title: "Transit Settings" },
		component: BusTrackerSettingsComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "busoverview",
		data: { title: "Bus Overview" },
		component: BusOverviewTableComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "geofencehistory",
		data: { title: "Geo Fence History" },
		component: BusTrackerGeoFenceHistoryComponent,
		canActivate: [AuthguardService]
	},
	{
		path: "mapdebug",
		data: { title: "Map Debug (SU Only)" },
		component: BusTrackerMapDebugComponent,		
		canActivate: [AuthguardService]
	},
];
